import { render, staticRenderFns } from "./Consume.vue?vue&type=template&id=4f409cd5&scoped=true"
import script from "./Consume.vue?vue&type=script&lang=js"
export * from "./Consume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f409cd5",
  null
  
)

export default component.exports